import logo from './logo.svg';
import './App.css';
import './Component.js';
import StockInfo from './StockInfo.js';
import StockDetails from './StockDetails.js';
import Component from './Component.js';

function App() {


  const stocks = [
    new StockDetails("VREIT",1000,1.88),
    new StockDetails("AREIT",100,39.70),
    new StockDetails("CNVRG",100,17.00),
    new StockDetails("BPI",10,130.70)
  ];





  return (
    <div className="App">
      <header className="App-header">
        
        <div style={{display: "flex", flexWrap: "wrap", gap: "10px", padding: "10px", alignItems: "center", justifyContent: "center"}}>
          {stocks.map((s, index) => {
            return (<StockInfo stock={s}/>);
          })}
        </div>

        
      </header>
    </div>
  );
}

export default App;
